// Pinned per-client Supplies views shown as quick-access entries under the
// Supplies sidebar group. Adding a client here is the ONLY change needed to
// surface a dedicated, company-scoped supplies/analytics/toner view — no new
// page components or routes. Replaces the old per-client page forks.
export const SUPPLY_CLIENTS = [
  { handle: 'papelera', companyId: 'e3667cd4-9786-4120-a8bc-59b51dccbe08', name: 'Papelera Berazategui' },
  { handle: 'respirar', companyId: '05640c93-aace-42be-92bb-69dd44bdfda4', name: 'Fundación Respirar' },
];

export function findSupplyClient(handle) {
  return SUPPLY_CLIENTS.find((c) => c.handle === handle) || null;
}
